export default "__VITE_ASSET__ad034524__"